export default __webpack_public_path__ + "static/media/video_bg.15767b44.jpg";